import * as React from 'react';
import { BaseComponent, BaseComponentProps, BaseComponentState } from '../base/BaseComponent';
export interface CategoryHotelsProps extends BaseComponentProps { 
    star: number;
    size?: 'small' | 'standard' | 'big';
}
export interface CategoryHotelsState extends BaseComponentState {
     
}

export class CategoryHotels extends BaseComponent<CategoryHotelsProps, CategoryHotelsState> {
    constructor(props: CategoryHotelsProps) {
        super(props); 
    }
 
    renderStart = () => {
        let startBlock = this.props.star! ? this.props.star! : 0;
        let lop = 0;
        let star: any[] = [];
        let startEmbpy = 5 - startBlock;
        for (let x = 1; x <= startBlock; x++) {
            star.push(<i key={lop} className={`if-star`} />);
            lop++;
        } 
        for (let x = 1; x <= startEmbpy; x++) {
            star.push(<i key={lop} className={`if-star-o`} />);
            lop++;
        } 
        return star;
    }

    render() {
        if (this.state.haveReactError) {
            return this.renderErrorPanel();
        } 
         
        return (
            <span key={'hstars'}>{this.renderStart()}</span>

        );
    }
}



// WEBPACK FOOTER //
// ./src/core/CategoryHotels.tsx